import React from 'react';

function SmsMessages(props) {
    return (
        <div className="SmsMessages" role="presentation">
            <div className="help-block">
                {!props.isSuccess && !props.isFailure &&
                    <span className="SmsMessages__msg">
                        <span className="hidden-xs">{props.cta}</span><span className="visible-xs-inline">{props.ctaShort}</span>
                    </span>
                }
                {props.isSuccess &&
                    <span className="SmsMessages__msg--success text-success" aria-live="polite" role="status">{props.success}</span>
                }
                {props.isFailure &&
                    <span className="SmsMessages__msg--failure" aria-live="assertive" role="alert">{props.failure}</span>
                }
            </div>
        </div>
    );
}

export default SmsMessages;
